import * as React from 'react';
import { FormControl, FormLabel, Radio, RadioGroup, } from '@mui/joy';
import { convertJSONKeyToTitle } from '../../helpers/KeyConverters';

function RadioButtonAutoForm(props) {
    const { label, labelMinWidth, values, defaultValue, disabled, name, required} = props;

    return (
        <FormControl orientation="horizontal">
            <FormLabel sx={{minWidth: labelMinWidth, fontSize: "1rem"}}>{label}:</FormLabel>
            <RadioGroup orientation="horizontal" name={name} defaultValue={defaultValue} disabled={disabled}>
                {values.map((value, index) => (
                    <Radio value={value} name={name} label={convertJSONKeyToTitle(value)} disabled={disabled} required={required && index === 0}/>
                ))}
            </RadioGroup>
        </FormControl>
    );
}

export default RadioButtonAutoForm;


